import keyBinder from 'shared/lib/keyBinder';
import { KeyScopes } from 'flux/stores/cuesheet/CuesheetConstants';
import { isGlobalElementManager } from 'main/components/show/cuesheet/cuesheetViewHelper';
import role from 'shared/lib/role';

import CuesheetActions from 'flux/actions/cuesheet/CuesheetActions';
import GlobalElementModalActions from 'flux/actions/GlobalElementModalActions';
import { UPCOMING_EVENT_FILTERS } from 'shared/constants/EventFilters';

/**
 * CuesheetPopulateMixin, for mixing with cuesheet components
 */
export default {
  /**
   * Populate the cuesheet data
   */
  populateCuesheet(params) {
    params = params || this.context.router.state.params;

    const { teamId, eventId, showId } = params;

    CuesheetActions.populate(teamId, eventId, showId);

    const isTeamAdmin = this._isTeamAdmin(teamId);

    /**
     * This auto populates the show dropdown inside of the global element manager
     * insert modal with the active show. We only want the active show to be populated if the
     * editor is in a view other than Global Element Manager.
     *
     * Only team admins have access to global element funtionality. So if user
     * isn't a team admin there is no need to populate the modal.
     */
    if (!isGlobalElementManager() && isTeamAdmin) {
      GlobalElementModalActions.populateEventList(
        teamId,
        UPCOMING_EVENT_FILTERS,
      );
    }
  },

  _isTeamAdmin(teamId) {
    const { user } = this.state;
    if (!user) return;

    return role.hasTeamAdminRole(user, teamId);
  },

  componentWillReceiveProps(nextProps) {
    // Fix for Issue#2140 - Back/Forward browser buttons fix
    if (nextProps.showId !== this.props.showId) {
      const { teamId, eventId, showId } = nextProps;

      this.populateCuesheet({ teamId, eventId, showId });
    }
  },

  componentDidMount() {
    this.populateCuesheet();

    keyBinder.setScope(KeyScopes.Default);
  },

  onRouteChange(params) {
    this.populateCuesheet(params);
  },
};
